'use strict';

/**
 * @author Maxim Seredkin
 */
import angular from 'angular';

export default ['$scope', '$routeParams', '$log', '$uibModalInstance', '$uibModal', 'tax', 'QuarterRestService', 'edit', 'taxes',
                function($scope, $routeParams, $log, $modalInstance, $modal, tax, QuarterRestService, edit, taxes) {
                    $scope.ok = ok;
                    $scope.cancel = cancel;
                    $scope.setTax = setTax;
                    $scope.edit = edit;
                    $scope.isUniqueTax = isUniqueTax;

                    $scope.tax = angular.copy(tax);
                    $scope.taxes = angular.copy(taxes);

                    $scope.phases = [
                        {
                            id: 'invest',
                            name: 'Инвестиционная',
                        },
                        {
                            id: 'perform',
                            name: 'Эксплуатационная',
                        },
                    ];

                    $scope.phaseOptions = $scope.phases.map((item) => item.id);
                    //$scope.tax.phase = $scope.phases.find((phase) => phase.id === tax.phase);

                    $scope.getPhaseName = (phase) => {
                        const currentPhase = $scope.phases.find((item) => item.id === phase);
                        return currentPhase ? currentPhase.name : '';
                    }

                    if (!angular.equals(tax, {})) {
                        $scope.taxes.splice(taxes.indexOf(tax), 1);
                    }

                    const startYear = 2012;
                    const endYear = new Date().getFullYear();
                    $scope.years = Array.from({length: endYear - startYear + 1}, (_, index) => startYear + index);
                    console.log($scope.years);

                    QuarterRestService.tree(null, (data) => {
                        //const years = Object.entries(data._embedded).map(([_key, value]) => value[0]);
                        $scope.quarters = Object.entries(data._embedded).map(([_key, value]) => value[0]);
                        if (tax.quarter == null) return;
                        const currentQuatter = data._embedded[tax.quarter.year];
                        $scope.tax.quarter = $scope.quarters.find((quarter) => quarter.year === currentQuatter.year);
                        // $scope.year = $scope.quarters[tax.quarter.year];

                        // if (!($scope.year != null && Array.isArray($scope.year))) return;

                        // $scope.tax.quarter = $scope.year.find((quarter) => quarter.id === tax.quarter.id);
                    });

                    // region Function

                    function ok() {
                        //$scope.tax.phase = $scope.tax.phase.id;
                        console.log($scope.tax)
                        $modalInstance.close($scope.tax);
                    }

                    function cancel() {
                        $modalInstance.dismiss();
                    }

                    function setTax(item) {
                        $scope.tax.tax = item;
                        $scope.selectedTax = item;
                    }

                    function checkRequiredBase() {
                        $scope.requiredTax = $scope.tax.tax != null && $scope.tax.tax.id != null;
                    }

                    function isUniqueTax() {
                        return !$scope.taxes.some((tx) => {
                            return equalsId(tx.quarter, $scope.tax.quarter)
                                   && equalsId(tx.tax, $scope.tax.tax);
                        });
                    }

                    function equalsId(obj1, obj2) {
                        if (!obj1) return false;
                        if (!obj2) return false;

                        return obj1.id === obj2.id;
                    }

                    // endregion

                    // region Watcher

                    $scope.$watch('tax.tax', function() {
                        checkRequiredBase();
                    });

                    // endregion
                }];
